import type { StaleDetailDay } from '@/types/cardReceivable';
import { formatDateBR } from './financialUtils';

/**
 * Frase do aviso de Detalhado desatualizado: quais dias/bandeiras e quantas
 * transações faltam. O Detalhado é uma foto — a cauda agendada dele só tem as
 * vendas feitas até a exportação —, então um dia pode ter sido "carregado" sem
 * todas as vendas e travar a baixa automática (caso 21/09/2026).
 */
export const staleDetailMessage = (days: StaleDetailDay[]): string => {
  if (days.length === 0) return '';
  const parts = days.map((d) => {
    const total = Math.max(d.file_transactions, d.expected_installments);
    return `${formatDateBR(d.date)} ${d.brand_label || d.brand} (${d.detailed_transactions} de ${total} vendas)`;
  });
  const plural = days.length > 1;
  return `${plural ? 'Estes dias estão' : 'Este dia está'} com o Detalhado desatualizado: ${parts.join(', ')}.`;
};
